export interface TrackerConfig {
    action?: string;
    category?: string;
    event?: string;
    label?: string;
}

export class Tracker {
    globalConfig: TrackerConfig;

    constructor(options?: TrackerConfig) {
        this.globalConfig = options || {};
    }

    trackEvent(config?: TrackerConfig): void {
        const _config = { ...this.globalConfig, ...config };

        if (
            window.dataLayer &&
            _config.event &&
            _config.category &&
            _config.action &&
            _config.label
        ) {
            window.dataLayer.push({
                event: _config.event,
                eventCategory: _config.category,
                eventAction: _config.action,
                eventLabel: _config.label,
            });
        }
    }

    addCustomDimension(cd: string, data: string): void {
        window?.dataLayer?.push({
            [cd]: data,
        });
    }
}
